/*
  Server address (динамический — учитывает суперадмин-режим)
*/

export const BACKEND_URL =
  (import.meta.env.VITE_APP_BACKEND_URL as string) || 'http://localhost:12097'


/*
  Graphql api endpoint address
*/

export const GRAPHQL_URI =
  (import.meta.env.VITE_APP_GRAPHQL_URI as string) ||
  `${BACKEND_URL}/api/v1.1/brand-manager/graph`

/*
  Rest-like Api endpoint addresses
*/

export const API_URL = `${BACKEND_URL}/api/v1/brand-manager`

/*
  Route to upload product preview image
*/

export const API_URL_UPLOAD_PRODUCT_PREVIEW = `${API_URL}/catalog/product/preview/upload`


/*
  Route to upload product preview image
*/

export const API_URL_UPLOAD_SHOP_IMAGE = `${API_URL}/shop-image/image/upload`

/**
 * Route to upload shop tag icon
 */

export const API_URL_UPLOAD_SHOP_TAG_ICON = `${API_URL}/shop-tag/icon/upload`

/*
  Route to upload brand logo image
*/

export const API_URL_UPLOAD_BRAND_LOGO = `${API_URL}/brand/logo/upload`

/*
  Route to upload brand files (PDF, images, etc.)
*/

export const API_URL_UPLOAD_BRAND_FILE = `${API_URL}/brand/file/upload`

/*
  Routes to upload category stuff
*/

export const API_URL_UPLOAD_CATEGORY_ICON = `${API_URL}/catalog/category/icon/upload`
export const API_URL_UPLOAD_CATEGORY_ALT_ICON = `${API_URL}/catalog/category/alt-icon/upload`

/*
  Routes to upload info banners
*/

export const API_URL_UPLOAD_BANNER_IMAGE = `${API_URL}/catalog/banner/slide/upload`
export const API_URL_UPLOAD_MOBILE_BANNER_IMAGE = `${API_URL}/catalog/banner/mobile-slide/upload`

/*
  Routes to upload info stories
*/

export const API_URL_UPLOAD_STORY_PREVIEW_IMAGE = `${API_URL}/catalog/story/preview/upload`
export const API_URL_UPLOAD_STORY_SLIDE_IMAGE = `${API_URL}/catalog/story/slide/upload`

/*
  Routes to upload info labels
*/

export const API_URL_UPLOAD_LABEL_IMAGE = `${API_URL}/marketing/label/image/upload`

/*
  Routes to upload info materials
*/

export const API_URL_UPLOAD_MATERIAL_PREVIEW_IMAGE = `${API_URL}/marketing/textMaterial/upload`